import { useState } from 'react';

import { Spin } from 'antd';

import MovieForm from './movie-form';

import TitledCard from '../../layout-components/titled-card';

const NewLocation: React.FC = () => {
  const [loading, setLoading] = useState(false);

  return (
    <Spin spinning={loading}>
      <TitledCard title="Nowy film" backUrl="..">
        <MovieForm setLoading={setLoading} />
      </TitledCard>
    </Spin>
  );
};
export default NewLocation;
